import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { appsettings } from '../shared/app.settings';
import { Product } from '../product/product.model';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class ProductService {
  public product = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
  ) { }

  getProduct(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/product/' + link)
      .map(
        (product) => {
          return product;
        });
  }

  getProducts(id: number, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/product/' + id, {
        responseType: 'json'
      })
      .map(
        (products) => {
          return products['products'];
        },
        error => console.log('Error ::' + error)
      );
  }


  getCategoryProducts(id: number, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/ category /' + id, {
        responseType: 'json'
      })
      .map(
        (products) => {
          // for (let product of products['products']) {
          //     product = [];
          // }
          return products['products'];
        },
        error => console.log('Error ::' + error)
      );
  }

  getHighlightedText(id: number, country: string, language: string) {
    return this.http
      .get<Product[]>(appsettings.rootUrl + country + '/' + language + '/product/' + id)
      .map(
        (highlightedTexts) => {
          return highlightedTexts[0].highlightedText;
        });
  }

  getFeatures(id: number, country: string, language: string) {
    return this.http
      .get<Product[]>(appsettings.rootUrl + country + '/' + language + '/product/' + id)
      .map(
        (features) => {
          return features[0].feature;
        });
  }

  getSpecs(id: number, country: string, language: string) {
    return this.http
      .get<Product[]>(appsettings.rootUrl + country + '/' + language + '/product/' + id)
      .map(
        (specs) => {
          return specs[0].spec;
        });
  }

  getFiles(id: number, country: string, language: string) {
    return this.http
      .get<Product[]>(appsettings.rootUrl + country + '/' + language + '/product/' + id)
      .map(
        (files) => {
          return files[0].file;
        });
  }



  getFilter(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/new-filter/' + link)
      .map(
        (filters) => {
          return filters;
        });
  }


  getFilterResult(link: string, country: string, language: string, filterList: any) {
    const queryList = [];
    for (let i = 0; i < filterList.length; i++) {
      queryList.push('filter[]=' + filterList[i]);
    }

      console.log(queryList);


    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/filter/product/' + link + '?' + queryList.join('&'))
      .map(
        (result: any[]) => {
          for (let i = 0; i < result.length; i++) {
            if(result[i].images.desktop) {
              result[i].images.desktop = result[i].images.desktop[0];
            }
          }

          return result;
        });
  }


  getImages(id: number, country: string, language: string) {
    return this.http
      .get<Product[]>(appsettings.rootUrl + country + '/' + language + '/product/' + id)
      .map(
        (images) => {
          return images[0].images;
        }
      );
  }

  search(country: string, language: string, query: string) {
    return this.http.get(
      appsettings.rootUrl + country + '/' + language + '/search/' + query
    );
  }


}
